module.exports = __webpack_public_path__ + "assets/img/NVIDIA-c0d4bda1.png";